const removeTrailingParam = (url: string) => {
	const urlArray = url.split("/");
	urlArray.pop();
	return urlArray.join("/");
};

export default removeTrailingParam;
